import React from 'react';
import { 
  Box, Typography, Paper, Button, Avatar, Chip, 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

// Helper function to generate a color from a string (name)
function stringToColor(string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

// Helper function to get initials from a name
function getInitials(name) {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .substring(0, 2);
}

// Mock data
const users = [
  { id: 1, name: 'Emma Johnson', email: 'emma@example.com', role: 'Admin', status: 'Active', plan: 'Pro', lastLogin: '2023-05-15' },
  { id: 2, name: 'Michael Chen', email: 'michael@example.com', role: 'User', status: 'Active', plan: 'Basic', lastLogin: '2023-05-14' },
  { id: 3, name: 'Sophia Williams', email: 'sophia@example.com', role: 'User', status: 'Inactive', plan: 'Enterprise', lastLogin: '2023-05-10' },
  { id: 4, name: 'James Brown', email: 'james@example.com', role: 'User', status: 'Active', plan: 'Pro', lastLogin: '2023-05-15' },
  { id: 5, name: 'Maria Garcia', email: 'maria@example.com', role: 'User', status: 'Active', plan: 'Basic', lastLogin: '2023-05-13' },
];

// The component uses a direct table implementation rather than a dynamic column definition

function Users() {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Users Management</Typography>
        <Button 
          variant="contained" 
          color="primary"
          startIcon={<PersonAddIcon />}
        >
          Add User
        </Button>
      </Box>
      
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Last Login</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar 
                      sx={{ 
                        bgcolor: stringToColor(user.name),
                        marginRight: 2
                      }}
                    >
                      {getInitials(user.name)}
                    </Avatar>
                    <Typography>{user.name}</Typography>
                  </Box>
                </TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell>
                  <Chip 
                    label={user.status} 
                    color={user.status === 'Active' ? 'success' : 'error'} 
                    size="small" 
                  />
                </TableCell>
                <TableCell>{user.plan}</TableCell>
                <TableCell>{user.lastLogin}</TableCell>
                <TableCell>
                  <Button size="small" variant="outlined">View</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default Users;
